import axios from 'axios'
import store from '@state/store'
// import api from '@src/helpers/api'
import multiRequest from '@utils/multi-request'
import endpoint from '@src/data/endpoint.json'

export default [
  {
    path: '/',
    redirect: { name: 'login' },
    // name: 'home',
    // component: () => lazyLoadView(import('@views/home')),
  },
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/login')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          const url = store.state.auth.currentUser.properties[0]
          // Redirect to the home page instead
          next({ name: 'dashboard', params: { url } })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => lazyLoadView(import('@views/profile')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/profile/:username',
    name: 'username-profile',
    component: () => lazyLoadView(import('@views/profile')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store
          // Try to fetch the user's information by their username
          .dispatch('users/fetchUser', { username: routeTo.params.username })
          .then((user) => {
            // Add the user to the route params, so that it can
            // be provided as a prop for the view component below.
            routeTo.params.user = user
            // Continue to the route.
            next()
          })
          .catch(() => {
            // If a user with the provided username could not be
            // found, redirect to the 404 page.
            next({ name: '404', params: { resource: 'User' } })
          })
      },
    },
    // Set the user from the route params, once it's set in the
    // beforeResolve route guard.
    props: (route) => ({ user: route.params.user }),
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.meta.authRequired
        )
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: 'login' } : { ...routeFrom })
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('@views/_404').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  {
    path: '/:url',
    component: require('@layouts/dashboard').default,
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        const { url } = routeTo.params
        store
          .dispatch('app/fetchProperty', { slug: url })
          .then(() => {
            next()
          })
          .catch(() => {
            next({ name: '404', params: { resource: 'Property' } })
          })
      },
    },
    children: [
      {
        path: '',
        redirect: { name: 'dashboard' },
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => lazyLoadView(import('@views/dashboard')),
      },
      {
        path: 'reservation',
        name: 'reservation',
        component: () => lazyLoadView(import('@views/reservation')),
        meta: {
          beforeResolve(routeTo, routeFrom, next) {
            multiRequest([
              {
                key: 'countryList',
                url: endpoint.dropdown.countries,
              },
            ])
              .then((data) => {
                Object.assign(routeTo.params, data)
                next()
              })
              .catch(() => {
                next({ name: '404', params: { resource: 'Rate Plan' } })
              })
          },
        },
        props: (route) => ({ ...route.params }),
      },
      {
        path: 'checkin',
        name: 'checkin',
        component: () => lazyLoadView(import('@views/checkin')),
      },
      {
        path: 'checkin/create',
        name: 'add-checkin',
        component: () => lazyLoadView(import('@views/add-checkin')),
        meta: {
          beforeResolve(routeTo, routeFrom, next) {
            axios
              .post(endpoint.checkin.create)
              .then((res) => {
                routeTo.params.dropdown = res.data.dropdown
                next()
              })
              .catch(() => {
                next({ name: '404', params: { resource: 'Checkin' } })
              })
          },
        },
        props: (route) => ({ ...route.params }),
      },
      {
        path: 'checkin/:id',
        name: 'edit-checkin',
        component: () => lazyLoadView(import('@views/edit-checkin')),
        meta: {
          beforeResolve(routeTo, routeFrom, next) {
            const property = store.state.app.currentProperty.id
            const { id } = routeTo.params
            axios
              .post(endpoint.checkin.get, {
                property,
                id,
              })
              .then((res) => {
                routeTo.params.dropdown = res.data.dropdown
                routeTo.params.item = res.data.data
                next()
              })
              .catch(() => {
                next({ name: '404', params: { resource: 'Checkin' } })
              })
          },
        },
        props: (route) => ({ ...route.params }),
      },
      {
        path: 'checkin/:id/checkin',
        name: 'process-checkin',
        component: () => lazyLoadView(import('@views/process-checkin')),
        meta: {
          beforeResolve(routeTo, routeFrom, next) {
            const property = store.state.app.currentProperty.id
            const { id } = routeTo.params
            axios
              .post(endpoint.checkin.processEdit, {
                property,
                id,
              })
              .then((res) => {
                routeTo.params.dropdown = res.data.dropdown
                routeTo.params.item = res.data.data
                next()
              })
              .catch(() => {
                next({ name: '404', params: { resource: 'Checkin' } })
              })
          },
        },
        props: (route) => ({ ...route.params }),
      },
      {
        path: 'checkin/:id/view',
        name: 'view-checkin',
        component: () => lazyLoadView(import('@views/view-checkin')),
        meta: {
          authRequired: true,
          beforeResolve(routeTo, routeFrom, next) {
            const property = store.state.app.currentProperty.id
            const { id } = routeTo.params

            axios
              .post(endpoint.checkin.view, {
                property,
                id,
              })
              .then(({ data }) => {
                routeTo.params.item = data.data
                next()
              })
              .catch(() => {
                next({ name: '404', params: { resource: 'Checkin' } })
              })
          },
        },
        props: (route) => ({ ...route.params }),
      },
      {
        path: 'inventory',
        name: 'inventory',
        component: () => lazyLoadView(import('@views/inventory')),
        meta: {
          beforeResolve(routeTo, routeFrom, next) {
            const propertyId = store.state.app.currentProperty.id
            multiRequest([
              {
                key: 'roomTypes',
                url: endpoint.roomType.list,
                data: {
                  propertyId,
                  selects: ['id', 'name'],
                },
              },
            ])
              .then((data) => {
                Object.assign(routeTo.params, data)
                next()
              })
              .catch(() => {
                next({ name: '404', params: { resource: 'Rate Plan' } })
              })
          },
        },
        props: (route) => ({ ...route.params }),
      },
      {
        path: 'promotion/:promotionId',
        name: 'promotion-detail',
        component: () => lazyLoadView(import('@views/promotion-detail')),
        meta: {
          beforeResolve(routeTo, routeFrom, next) {
            const propertyId = store.state.app.currentProperty.id
            const promotionId = routeTo.params.promotionId
            const requests = [
              {
                key: 'ratePlans',
                url: endpoint.ratePlan.list,
                data: {
                  propertyId,
                  selects: ['id', 'name'],
                },
              },
              // {
              //   key: 'roomTypes',
              //   url: endpoint.roomType.list,
              //   data: {
              //     propertyId,
              //     selects: ['id', 'name'],
              //   },
              // },
              {
                key: 'cancellations',
                url: endpoint.dropdown.cancellation,
              },
              {
                key: 'dayOfWeek',
                url: endpoint.dropdown.dayOfWeek,
              },
              {
                key: 'promotionTypes',
                url: endpoint.dropdown.promotionTypes,
              },
            ]

            if (promotionId !== 'new') {
              requests.push({
                key: 'item',
                url: endpoint.promotion.get,
                data: { id: promotionId, propertyId },
              })
            }

            multiRequest(requests)
              .then((data) => {
                if (
                  promotionId === 'new' &&
                  !!routeTo.query.type &&
                  !data.promotionTypes.some(
                    (typ) => typ.code === routeTo.query.type
                  )
                ) {
                  return next({
                    name: 'promotion',
                    params: { url: routeTo.params.url },
                  })
                }

                Object.assign(routeTo.params, data)

                next()
              })
              .catch(() => {
                next({ name: '404', params: { resource: 'Rate Plan' } })
              })
          },
        },
        props: (route) => ({ ...route.params }),
      },
      {
        path: 'promotion',
        name: 'promotion',
        component: () => lazyLoadView(import('@views/promotion-list')),
        meta: {
          beforeResolve(routeTo, routeFrom, next) {
            multiRequest([
              {
                key: 'promotionTypes',
                url: endpoint.dropdown.promotionTypes,
              },
            ])
              .then((data) => {
                Object.assign(routeTo.params, data)
                next()
              })
              .catch(() => {
                next({ name: '404', params: { resource: 'Rate Plan' } })
              })
          },
        },
        props: (route) => ({ ...route.params }),
      },
      {
        path: 'rate-plan/:ratePlanId',
        name: 'rate-plan-detail',
        component: () => lazyLoadView(import('@views/rate-plan-detail')),
        meta: {
          beforeResolve(routeTo, routeFrom, next) {
            const propertyId = store.state.app.currentProperty.id
            const ratePlanId = routeTo.params.ratePlanId
            const requests = [
              {
                key: 'roomTypes',
                url: endpoint.roomType.list,
                data: {
                  propertyId: propertyId,
                  selects: ['id', 'name'],
                },
              },
              {
                key: 'cancellations',
                url: endpoint.dropdown.cancellation,
              },
            ]

            if (ratePlanId !== 'new') {
              requests.push({
                key: 'item',
                url: endpoint.ratePlan.get,
                data: { id: ratePlanId, propertyId },
              })
            }

            multiRequest(requests)
              .then((data) => {
                Object.assign(routeTo.params, data)
                next()
              })
              .catch(() => {
                next({ name: '404', params: { resource: 'Rate Plan' } })
              })
          },
        },
        props: (route) => ({ ...route.params }),
      },
      {
        path: 'rate-plan',
        name: 'rate-plan',
        component: () => lazyLoadView(import('@views/rate-plan-list')),
      },
      {
        path: 'room-type',
        name: 'room-type',
        component: () => lazyLoadView(import('@views/room-type')),
      },
      {
        path: 'extra',
        name: 'extra',
        component: () => lazyLoadView(import('@views/extra')),
      },
      {
        path: 'point',
        name: 'point',
        component: () => lazyLoadView(import('@views/point')),
      },
      {
        path: 'redeem',
        name: 'redeem',
        component: () => lazyLoadView(import('@views/redeem')),
      },
      // {
      //   path: 'member/:memberId',
      //   name: 'member-detail',
      //   component: () => lazyLoadView(import('@views/member-detail')),
      //   meta: {
      //     beforeResolve(routeTo, routeFrom, next) {
      //       const propertyId = store.state.app.currentProperty.id
      //       const memberId = routeTo.params.memberId
      //       const requests = [
      //         {
      //           key: 'countries',
      //           url: endpoint.dropdown.countries,
      //         },
      //       ]

      //       if (memberId !== 'new') {
      //         requests.push({
      //           key: 'member',
      //           url: endpoint.member.get,
      //           data: { id: memberId, propertyId },
      //         })
      //       }

      //       multiRequest(requests)
      //         .then((data) => {
      //           Object.assign(routeTo.params, data)
      //           next()
      //         })
      //         .catch(() => {
      //           next({ name: '404', params: { resource: 'Rate Plan' } })
      //         })
      //     },
      //   },
      //   props: (route) => ({ ...route.params }),
      // },
      {
        path: 'member',
        name: 'member',
        component: () => lazyLoadView(import('@views/member')),
        meta: {
          beforeResolve(routeTo, routeFrom, next) {
            multiRequest([
              {
                key: 'titles',
                url: endpoint.dropdown.titles,
              },
              {
                key: 'countries',
                url: endpoint.dropdown.countries,
              },
            ])
              .then((data) => {
                Object.assign(routeTo.params, data)
                next()
              })
              .catch(() => {
                next({ name: '404', params: { resource: 'Member' } })
              })
          },
        },
        props: (route) => ({ ...route.params }),
      },
      {
        path: 'property',
        name: 'property',
        component: () => lazyLoadView(import('@views/property')),
        meta: {
          beforeResolve(routeTo, routeFrom, next) {
            const { url } = routeTo.params
            multiRequest([
              {
                key: 'property',
                url: endpoint.property.get,
                data: { slug: url },
              },
              {
                key: 'countries',
                url: endpoint.dropdown.countries,
              },
              {
                key: 'starRates',
                url: endpoint.dropdown.starRates,
              },
              {
                key: 'timeZones',
                url: endpoint.dropdown.timeZones,
              },
              {
                key: 'currencies',
                url: endpoint.dropdown.currencies,
              },
              {
                key: 'times',
                url: endpoint.dropdown.times,
              },
            ])
              .then((data) => {
                Object.assign(routeTo.params, data)
                next()
              })
              .catch(() => {
                next({ name: '404', params: { resource: 'Property' } })
              })
          },
        },
        props: (route) => ({ ...route.params }),
      },
    ],
  },
  {
    path: '/:url/checkin/:id/print',
    name: 'print-checkin',
    component: () => lazyLoadView(import('@views/print-checkin')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        const { url, id } = routeTo.params

        store
          .dispatch('app/fetchProperty', { slug: url })
          .then((property) => {
            // get check-in details
            axios
              .post(endpoint.checkin.print, { property: property.id, id })
              .then(({ data }) => {
                routeTo.params.checkIn = data.data
                next()
              })
              .catch(() => {
                next({ name: '404', params: { resource: 'Checkin' } })
              })
          })
          .catch(() => {
            next({ name: '404', params: { resource: 'Property' } })
          })
      },
    },
    props: (route) => ({ checkIn: route.params.checkIn }),
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
]

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@views/_loading').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/_timeout').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
